import React, { useState, useContext, useRef } from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import useMedia from '@/hooks/useMedia'
import { isEmpty } from 'lodash-es'

// Components
import Popup from '@/components/common/Popup'
import Drawer from '@/components/common/Drawer'
import LiveRoom from './components/LiveRoom'
import Price from './components/Price'
import LiveRoomList from './components/LiveRoomList'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

// Context
import { liveStreamingPreviewContext } from '@/components/pages/Product/component/ValidProduct'

interface IProps {
  price: number
  origPrice: number
}

const FIRST_PAGE_INDEX = 0

const LiveStreamingPreview = (props: IProps) => {
  const { price, origPrice } = props
  const { t } = useTranslation()
  const { isMobile, isTablet, isDesktop } = useMedia()
  const { liveRoomListDataInstance } = useContext<any>(liveStreamingPreviewContext)
  const { data: liveRoomList } = liveRoomListDataInstance
  const liveRoomListPopupRef = useRef<any>(null)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const limitedLiveRoomList = !isEmpty(liveRoomList?.pages[FIRST_PAGE_INDEX]?.roomList)
    ? liveRoomList?.pages[FIRST_PAGE_INDEX]?.roomList?.slice(0, 2)
    : []

  const handleClick = () => {
    if (isDesktop) {
      liveRoomListPopupRef.current.setIsPopupOpen(true)
    } else {
      setIsDrawerOpen(true)
    }
  }

  return (
    <>
      <div className={cx('live-streaming-preview')}>
        <div className={cx('live-streaming-preview__header')}>
          <div className={cx('live-streaming-preview__header-left')}>
            <div className={cx('live-streaming-preview__header-title')}>{t('LiveStreamingPreview_Title')}</div>
            <div className={cx('live-streaming-preview__header-subtitle')}>👉 {t('LiveStreamingPreview_Subtitle')}</div>
          </div>
          <div onClick={handleClick} className={cx('live-streaming-preview__header-right')}>
            {t('Common_More_Live_Streaming_Rooms')}
          </div>
        </div>

        {isDesktop && price > 0 && (
          <div className={cx('live-streaming-preview__desktop-price-slot')}>
            <Price price={price} origPrice={origPrice} />
          </div>
        )}

        <div className={cx('live-streaming-preview__content')}>
          {(isTablet || isMobile) && price > 0 && <Price price={price} origPrice={origPrice} />}

          <div className={cx('live-streaming-preview__live-room-list')}>
            {limitedLiveRoomList.map((liveRoom: any) => (
              <LiveRoom
                key={liveRoom.roomId}
                isSingle={limitedLiveRoomList.length === 1}
                roomId={liveRoom.roomId}
                title={liveRoom.title}
                kolName={liveRoom.kolName}
                startTime={liveRoom.startTime}
                liveType={liveRoom.liveType}
                liveSourceType={liveRoom.liveSourceType}
              />
            ))}
          </div>
        </div>
      </div>

      {isDesktop && (
        <Popup ref={liveRoomListPopupRef} hasConfirm={false} hasCancel={false}>
          <LiveRoomList originalPrice={origPrice} price={price} />
        </Popup>
      )}

      {(isTablet || isMobile) && (
        <Drawer
          className={cx('live-streaming-preview__live-room-list-drawer')}
          open={isDrawerOpen}
          direction='bottom'
          onClose={() => setIsDrawerOpen(false)}
          lockBackgroundScroll
        >
          <LiveRoomList originalPrice={origPrice} price={price} />
        </Drawer>
      )}
    </>
  )
}

export default LiveStreamingPreview
